// Variant change
this.customVariantChangeEvent = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    console.info('%c[Variant changed]', 'color: #5fb8ff')
    updateProductPrice(event.data.variant);
});

// Cart change
this.customCartChangeEvent = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    console.info('%c[Cart updated]', 'color: #5fb8ff')
});

// Cart error
this.customCartErorrEvent = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
    console.info('%c[Cart error]', 'color: #5fb8ff')
});

// Qty change
this.customQtyChangeEvent = subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
    console.info('%c[Quantity updated]', 'color: #5fb8ff')
});

// Options change
this.customOptionsChangeEvent = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
    console.info('%c[Options change]', 'color: #5fb8ff')
});

function updateProductPrice(variant) {
    const priceContainer = document.querySelector('[data-price-field]');
    if (!priceContainer) return;

    const priceHtml = [];

    if (variant.compare_at_price > variant.price) {
        priceHtml.push(`
            <span class="inline-block line-through product-compare-price">
                ${formatMoney(variant.compare_at_price)}
            </span>
            <span class="inline-block text--price on-sale">
                ${formatMoney(variant.price)}
            </span>
        `);
    } else {
        priceHtml.push(`
            <span class="text--price">
                ${formatMoney(variant.price)}
            </span>
        `);
    }

    priceContainer.innerHTML = `
        <div class="flex gap-1 leading-none">
            ${priceHtml.join('')}
        </div>
    `;
}

function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    return '£' + (cents / 100).toFixed(2);
}